import { startsWith, upperFirst } from 'lodash';
import {
    STATUS_PATH,
    TICKETS_FULL_SIZE_PATH,
    TICKETS_WITH_CAPACITY_WAITLIST_PATH,
} from '../constants';

const _getActionNameFromPath = (checkoutStep: string) => {
    let pathName = checkoutStep;

    if (checkoutStep === TICKETS_WITH_CAPACITY_WAITLIST_PATH) {
        pathName = TICKETS_FULL_SIZE_PATH;
    } else if (startsWith(checkoutStep, STATUS_PATH)) {
        pathName = STATUS_PATH;
    }

    return `${upperFirst(pathName)}Load`;
};

export const trackPageLoad = ({
    checkoutStep,
    label,
    experimentId,
}: {
    checkoutStep: string;
    label?: string;
    experimentId?: string;
}) => ({
    type: 'TRACK_PAGE_LOAD',
    meta: {
        analytics: {
            action: _getActionNameFromPath(checkoutStep),
            label,
            dimensions: {
                checkoutStep,
                ...(experimentId ? { experimentId3: experimentId } : {}),
            },
        },
    },
});
